/**
 * PushPermissionGate — 알림 권한이 거부된 사용자에게 "설정으로 이동" 확인을 띄우는
 * headless gate. RootLayout 에 1회 마운트되어 앱 어디서든 동작.
 *
 * pushPromptStore.settingsOpen 을 구독 → ensurePushPermission({ allowSettingsPrompt: true })
 * 가 denied 상태에서 openSettings() 를 호출하면 다이얼로그 표시.
 *
 * ⚠ 2026-08-25 — 문구가 템플릿(픽쿠리) 것이었다: "쿠지 차례 등 중요한 소식".
 *   peeka 에는 쿠지가 없다. 알림 센터의 권한 배너와 같은 문구를 쓰도록 i18n 으로 옮겼다.
 */
import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';
import { usePushPromptStore } from '../../store/pushPromptStore';
import { openPushSettings } from '../../native/pushPermission';

export default function PushPermissionGate() {
  const { t } = useTranslation('notification');
  const settingsOpen = usePushPromptStore((s) => s.settingsOpen);
  const close = usePushPromptStore((s) => s.close);

  const handlePrimary = async () => {
    await openPushSettings();
    close();
  };

  return (
    <ConfirmDialog
      open={settingsOpen}
      onClose={close}
      title={t('pushOffTitle')}
      description={t('pushOffBody')}
      primaryText={t('pushOffAction')}
      secondaryText={t('later')}
      onPrimaryPressed={handlePrimary}
      onSecondaryPressed={close}
    />
  );
}
